import React, { Component } from 'react';
import PropTypes from 'prop-types';

const supportedSystems = [
  "chrome",
  "firefox",
  "safari",
  "ios",
  "edge"
];

class BrowserDetector extends Component {
  supportedBrowserCheckandRender(name) {
    if ((name !== null) && !supportedSystems.includes(name)) {
      return (
        <div className="browser-detector__content container page">
          <div className="browser-detector__content-inner title is-5">
            You are not using a supported browser, please use the latest version of Chrome, Firefox or Safari
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
      return (
        <div className="browser-detector">
          {this.supportedBrowserCheckandRender(this.props.browserName)}
        </div>
      );
    }
}

BrowserDetector.propTypes = {
  browserName: PropTypes.string,
};

export default BrowserDetector;
